export enum WelcomeModeEnum {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed',
}
